import EnLang from "./entries/en-US";
import FrLang from "./entries/fr-FR";
import PtLang from "./entries/pt-BR";

const AppLocale = {
  en: EnLang,
  fr: FrLang,
  pt: PtLang,
};

export default AppLocale;
